import { render, staticRenderFns } from "./NotificationCenterItem.vue?vue&type=template&id=07324a36&scoped=true&"
import script from "./NotificationCenterItem.vue?vue&type=script&lang=js&"
export * from "./NotificationCenterItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenterItem.vue?vue&type=style&index=0&id=07324a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07324a36",
  null
  
)

export default component.exports